import { AnimatePresence, motion } from "motion/react";
import { ReactNode } from "react";
import { SettingsIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

export default function AccountCharSettings({ open, onClose, children }: Props) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ scale: 0.98, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.98, opacity: 0 }}
          transition={{ duration: 0.1 }}
          className="absolute inset-0 card bg-matched/[.98] z-2 backdrop-blur flex flex-col rounded-[1rem]"
        >
          <div className="font-bold text-sm mb-5 flex items-center uppercase">
            <SettingsIcon size={16} className="mr-2.5" />
            Настройки персонажа
          </div>
          <div className="grid grid-cols-1 gap-2.5">{children}</div>
          <Button onClick={onClose} className="w-full mt-auto h-11">
            Закрыть
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
